import { actions } from './actions'

const initialState = {
  data: [],
}

export default function profileReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_PROFILE_RESULT:
      return { ...state, data: action.payload.data }
    default:
      return state
  }
}
